import React, { useRef, useState } from 'react';
import Grid from '../layout/grid';

const MAXIMO_LADO = 1600;
const QUALIDADE = .82;

const redimensionarImagem = arquivo => new Promise((
    resolve,
    reject
) => {
    const leitor = new FileReader();

    leitor.onerror = () => reject(
        new Error('Não foi possível ler a imagem.')
    );

    leitor.onload = evento => {
        const imagem = new Image();

        imagem.onerror = () => reject(
            new Error('O arquivo selecionado não é uma imagem válida.')
        );

        imagem.onload = () => {
            const proporcao = Math.min(
                1,
                MAXIMO_LADO / Math.max(
                    imagem.width,
                    imagem.height
                )
            );
            const canvas = document.createElement('canvas');

            canvas.width = Math.round(imagem.width * proporcao);
            canvas.height = Math.round(imagem.height * proporcao);

            const contexto = canvas.getContext('2d');
            contexto.drawImage(
                imagem,
                0,
                0,
                canvas.width,
                canvas.height
            );

            resolve(
                canvas.toDataURL('image/jpeg', QUALIDADE)
            );
        };

        imagem.src = evento.target.result;
    };

    leitor.readAsDataURL(arquivo);
});

export default props => {
    const inputArquivo = useRef(null);
    const inputCamera = useRef(null);
    const [erro, setErro] = useState('');
    const valor = props.input
        ? props.input.value
        : props.value;

    const selecionar = async evento => {
        const arquivo = evento.target.files[0];
        evento.target.value = '';

        if (!arquivo) {
            return;
        }

        if (!arquivo.type.startsWith('image/')) {
            setErro('Selecione um arquivo de imagem.');
            return;
        }

        try {
            setErro('');
            const imagem = await redimensionarImagem(arquivo);

            if (props.input) {
                props.input.onChange(imagem);
            } else if (props.onChange) {
                props.onChange(imagem);
            }
        } catch (ex) {
            setErro(ex.message);
        }
    };

    const remover = () => {
        if (props.input) {
            props.input.onChange(null);
        } else if (props.onChange) {
            props.onChange(null);
        }
    };

    return (
        <Grid cols={props.cols}>
            <div className='form-group'>
                {props.label &&
                    <label>{props.label}</label>}

                <div>
                    {valor &&
                        <img
                            src={valor}
                            alt='Nota fiscal'
                            style={{
                                display: 'block',
                                width: '100%',
                                maxWidth: 360,
                                maxHeight: 260,
                                objectFit: 'contain',
                                marginBottom: 10,
                                border: '1px solid #d7dce1',
                                borderRadius: 6
                            }}
                        />}

                    {!props.readOnly &&
                        <React.Fragment>
                            <button
                                type='button'
                                className='btn btn-primary'
                                style={{ marginRight: 6 }}
                                onClick={() =>
                                    inputArquivo.current.click()
                                }
                            >
                                <i
                                    className='fas fa-paperclip'
                                    style={{ marginRight: 6 }}
                                />
                                Anexar imagem
                            </button>

                            <button
                                type='button'
                                className='btn btn-info'
                                style={{ marginRight: 6 }}
                                onClick={() =>
                                    inputCamera.current.click()
                                }
                            >
                                <i
                                    className='fas fa-camera'
                                    style={{ marginRight: 6 }}
                                />
                                Tirar foto
                            </button>

                            {valor &&
                                <button
                                    type='button'
                                    className='btn btn-danger'
                                    onClick={remover}
                                >
                                    <i
                                        className='fas fa-trash'
                                        style={{ marginRight: 6 }}
                                    />
                                    Remover
                                </button>}

                            <input
                                ref={inputArquivo}
                                type='file'
                                accept='image/*'
                                style={{ display: 'none' }}
                                onChange={selecionar}
                            />

                            <input
                                ref={inputCamera}
                                type='file'
                                accept='image/*'
                                capture='environment'
                                style={{ display: 'none' }}
                                onChange={selecionar}
                            />
                        </React.Fragment>}

                    {props.readOnly && !valor &&
                        <div className='text-muted'>
                            Nenhuma imagem anexada.
                        </div>}

                    {erro &&
                        <div
                            className='text-danger'
                            style={{ marginTop: 6 }}
                        >
                            {erro}
                        </div>}
                </div>
            </div>
        </Grid>
    );
};
